<template>
  <div class="section container">
    <div class="section-header">
      <div class="section-title">
        <div class="section-icon section-icon-phone-number" :class="brandClass()"></div>
        <h3 class="section-title-label">
          {{$t("profile_personal_data_phone_summary_title")}}
        </h3>
        <div class="section-subtitle-label">
          {{ $t("profile_personal_data_phone_summary_subtitle") }}
        </div>
      </div>
      
      <div
        v-if="!editMode"
        class="section-edit pointer"
        :class="{ hidden: editDisabled }"
        @click="editClicked()"
        @keydown="ariaClick"
        role="button"
        tabindex="0"
      >
        <div class="section-edit-icon"></div>
        <div class="section-edit-label">
          {{ $t("profile_edit_button") }}
        </div>
      </div>
    </div>

    <div class="infos phone-information">


      <div class="phone-typology-container info">
        <div class="label phone-label">
          {{privateTelLabel}}
        </div>
        <div>
          <OnePhoneNumber
            v-for="phone in privateTelNumbers"
            :key="phone.consGUID || phone.tmp || 'new'"
            :selectId="'private-tel'"
            :communicationPhone="phone"
            :preferred="phone.preferred"
            @onPreferredChange="handlePreferredPhone(phone)"
            @onDelete="onDeleteClick(phone)"
            v-model="phone.value"
            :isInputDisabled="isThereMoreThanOnePhoneNumberInAnyPhoneTypology"
            :is-edit-mode="editMode"
          ></OnePhoneNumber>
          <!-- Info message (2+ numbers in the same phone typology) -->
          <!-- <div
            v-if="!editMode && privateTelNumbers.length >= 2"
            class="infobox">
            <div class="infobox-icon" />
            <div class="infobox-text">
              {{ $t('profile_personal_data_phone_summary_add_phone_info') }}
            </div>
          </div> -->

          <div 
            v-if="isThereMoreThanOnePrivateTel" 
            style="margin-bottom: 1rem">
            <NotificationBox :messageTextKey="'profile_personal_data_phone_summary_add_phone_info'" />
          </div>

          <div
            v-if="!editMode && privateTelNumbers.length === 0"
            class="add"
            :class="{
            'pointer': true,
            'hidden' : editDisabled
            }"
            @click="editClicked('private-tel-custom-select-plus-countryCode')">
            <div
              @keydown="ariaClick"
              role="button"
              tabindex="0"
              class="add-icon"
              :class="brandClass()"
              :aria-label="$t('profile_personal_data_phone_summary_add_phone')"
            />
            <div class="add-label">
              {{ $t("profile_personal_data_phone_summary_add_phone") }}
            </div>
          </div>
        </div>
      </div>

      <div class="phone-typology-container info">
        <div class="label phone-label">
          {{privateMobLabel}}
        </div>
        <div>
          <OnePhoneNumber
            v-for="phone in privateMobNumbers"
            :key="phone.consGUID || phone.tmp || 'new'"
            :selectId="'private-mob'"
            :communicationPhone="phone"
            @onPreferredChange="handlePreferredPhone(phone)"
            @onDelete="onDeleteClick(phone)"
            v-model="phone.value"
            :isInputDisabled="isThereMoreThanOnePhoneNumberInAnyPhoneTypology"
            :is-edit-mode="editMode"
          ></OnePhoneNumber>
          <!-- Info message (2+ numbers in the same phone typology) -->
          <!-- <div
            v-if="!editMode && privateMobNumbers.length >= 2"
            class="infobox">
            <div class="infobox-icon" />
            <div class="infobox-text">
              {{ $t('profile_personal_data_phone_summary_add_phone_info') }}
            </div>
          </div> -->

          <div 
            v-if="isThereMoreThanOnePrivateMob" 
            style="margin-bottom: 1rem">
            <NotificationBox :messageTextKey="'profile_personal_data_phone_summary_add_phone_info'" />
          </div>
          
          <div
            v-if="!editMode && privateMobNumbers.length === 0"
            class="add"
            :class="{
            'pointer': true,
            'hidden' : editDisabled
            }"
            @click="editClicked('private-mob-custom-select-plus-countryCode')">
            <div
              @keydown="ariaClick"
              role="button"
              tabindex="0"
              class="add-icon"
              :class="brandClass()"
              :aria-label="$t('profile_personal_data_phone_summary_add_phone')"
            />
            <div class="add-label">
              {{ $t("profile_personal_data_phone_summary_add_phone") }}
            </div>
          </div>
        </div>
      </div>

      <div class="phone-typology-container info">
        <div class="label phone-label">
          {{businessTelLabel}}
        </div>
        <div>
          <OnePhoneNumber
            v-for="phone in businessTelNumbers"
            :key="phone.consGUID || phone.tmp || 'new'"
            :selectId="'business-tel'"
            :communicationPhone="phone"
            @onPreferredChange="handlePreferredPhone(phone)"
            @onDelete="onDeleteClick(phone)"
            v-model="phone.value"
            :isInputDisabled="isThereMoreThanOnePhoneNumberInAnyPhoneTypology"
            :is-edit-mode="editMode"
          ></OnePhoneNumber>
          <!-- Info message (2+ numbers in the same phone typology) -->
          <!-- <div
            v-if="!editMode && businessTelNumbers.length >= 2"
            class="infobox">
            <div class="infobox-icon" />
            <div class="infobox-text">
              {{ $t('profile_personal_data_phone_summary_add_phone_info') }}
            </div>
          </div> -->

          <div 
            v-if="isThereMoreThanOneBusinessTel" 
            style="margin-bottom: 1rem">
            <NotificationBox :messageTextKey="'profile_personal_data_phone_summary_add_phone_info'" />
          </div>

          <div
            v-if="!editMode && businessTelNumbers.length === 0"
            class="add"
            :class="{
            'pointer': true,
            'hidden' : editDisabled
            }"
            @click="editClicked('business-tel-custom-select-plus-countryCode')">
            <div
              @keydown="ariaClick"
              role="button"
              tabindex="0"
              class="add-icon"
              :class="brandClass()"
              :aria-label="$t('profile_personal_data_phone_summary_add_phone')"
            />
            <div class="add-label">
              {{ $t("profile_personal_data_phone_summary_add_phone") }}
            </div>
          </div>
        </div>
      </div>

      <div class="phone-typology-container info">
        <div class="label phone-label">
          {{businessMobLabel}}
        </div>
        <div>
          <OnePhoneNumber
            v-for="phone in businessMobNumbers"
            :key="phone.consGUID || phone.tmp || 'new'"
            :selectId="'business-mob'"
            :communicationPhone="phone"
            @onPreferredChange="handlePreferredPhone(phone)"
            @onDelete="onDeleteClick(phone)"
            v-model="phone.value"
            :isInputDisabled="isThereMoreThanOnePhoneNumberInAnyPhoneTypology"
            :is-edit-mode="editMode"
          ></OnePhoneNumber>
          <!-- Info message (2+ numbers in the same phone typology) -->
          <!-- <div
            v-if="!editMode && businessMobNumbers.length >= 2"
            class="infobox">
            <div class="infobox-icon" />
            <div class="infobox-text">
              {{ $t('profile_personal_data_phone_summary_add_phone_info') }}
            </div>
          </div> -->

          <div 
            v-if="isThereMoreThanOneBusinessMob" 
            style="margin-bottom: 1rem">
            <NotificationBox :messageTextKey="'profile_personal_data_phone_summary_add_phone_info'" />
          </div>

          <div
            v-if="!editMode && businessMobNumbers.length === 0"
            class="add"
            :class="{
            'pointer': true,
            'hidden' : editDisabled
            }"
            @click="editClicked('business-mob-custom-select-plus-countryCode')">
            <div
              @keydown="ariaClick"
              role="button"
              tabindex="0"
              class="add-icon"
              :class="brandClass()"
              :aria-label="$t('profile_personal_data_phone_summary_add_phone')"
            />
            <div class="add-label">
              {{ $t("profile_personal_data_phone_summary_add_phone") }}
            </div>
          </div>
        </div>
      </div>



      
      <!-- Add / edit form buttons -->
      <div 
        v-if="editMode" 
        class="buttonsContainer">

        <!-- Apply button -->
        <OneButton
          :brandClass="brandClass()"
          :profileStyle="true"
          :type="'primary'"
          :label="$t('profile_apply_button')"
          :disabled="isButtonDisabled"
          @click="applyChanges()"
        />

        <!-- Cancel button -->
        <OneButton
          :brandClass="brandClass()"
          :profileStyle="true"
          :type="'secondary'"
          :label="$t('profile_cancel_button')"
          @click="cancelEditClicked()"
        />
      </div>
    </div>

    <!-- Section end horizontal rule -->
    <hr alt="" role="presentation">

    <!-- Delete popup -->
    <OneAlert
      :brandClass="brandClass()"
      v-if="showPopup"
      :title="this.$t('profile_personal_data_delete_phone_title')"
      :content="this.$t('profile_personal_data_delete_phone_subtitle')"
      :button_confirm_label="this.$t('profile_personal_data_delete_phone_confirm_button')"
      :button_cancel_label="this.$t('profile_personal_data_delete_phone_cancel_button')"
      @confirm="remove"
      @close="closeDeletePopup"
    />
  </div>
</template>

<style lang="scss">
  .section-icon-phone-number {
    background-image: url('~@/assets/default/light/phone-default-light.svg');
    &.__d{
      background-image: url('~@/assets/default/dark/phone-default-dark.svg');
    }
    &.__m {
      background-image: url('~@/assets/mini/light/phone-mini-light.svg');
      &.__d{
        background-image: url('~@/assets/mini/dark/phone-mini-dark.svg');
      }
    }
  }
  .phone-wrapper{
    .phone-countrycode-select{
      display: inline-block;
      width: 140px;
      label{
        width: 400%;
      }
      .custom-error{
        width: 400%;
      }
    }
    .phone-input{
      width: calc(100% - 140px) !important;
      border-left: 0px !important;
      padding-right: 0 !important;
      display: inline-block;
    }
  }
  .form{
    margin-top: 22px;
  }
  .buttonsContainer{
    margin-top: 40px;
  }

  .phone-typology-container {
    width: 100% !important;

    .phone-label {
      margin-bottom: 1rem;
    }

    .info-container {
      display: flex !important;
      align-items: center;

      &:last-child {
        margin-bottom: 21px !important;
      }

      .radio {
        position: static !important;
      }

      .value {
        margin-left: 1rem !important;
        font-size: 16px;
        margin-top: 0 !important;
      }

      .infos {
        padding: 0 !important;
        display: flex;
        align-items: center;

        .info {
          width: 100% !important;
          margin-bottom: 0 !important;

          .delete {
            position: static !important;
            margin-left: 1rem;
          }
        }
      }
    }

    .add {
      padding-left: 0 !important;
      margin-bottom: 21px !important;
    }

    .form {
      margin: 0 !important;
      padding: 0 !important;

      .custom-label {
        display: none !important;
      }
    }
  }

  .infobox {
    background-color: #F2F2F2;
    display: flex;
    padding: 1rem;
    margin-bottom: 12px;

    .infobox-icon {
      background-image: url('~@/assets/default/light/message-info-default-light.svg');
      background-size: 20px 20px;
      width: 7%;
      min-height: 21px;
      background-repeat: no-repeat;
      padding-right: 1rem;
    }

    .infobox-text {
      max-width: 93%;
    }
  }

  .noPhone {
    background: #DDE8F9;
    padding: 1rem;
  }
  .infoContainer {
    display: inline-flex;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .infoContainer {
    &.__rr {
      .enterPhone {
        font-family: RivieraNights-Regular;
      }
    }
  }
  .edit-icon{
    background-image: url('~@/assets/default/light/edit-default-light.svg');
    width: 12px;
    height: 20px;
    padding-right: 15px;
    background-repeat: no-repeat;
  }
  .enterPhone {
    color: $black;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
      &:hover{
        text-decoration-line: underline;
      }
  }
</style>

<script>
import useVuelidate from '@vuelidate/core'
import oneUtils from "../../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";

import {
  required
} from "@vuelidate/validators";
import OnePhoneNumber from "@/components/ProfileForm/components/OnePhoneNumber";
import NotificationBox from "@/components/ProfileForm/components/NotificationBox";

export default {
  inject:['$c', '$t', 'brandClass'],
  emits: ['isEditMode'],
  components: {
    OnePhoneNumber,
    NotificationBox
  },
  setup() {
    return { v$: useVuelidate() }
  },
  name: "ProfilePhoneNumbers",
  //validations from vuelidate
  mixins: [oneUtils.customValidationMixin, oneUtils.accessibilityMixin],
  props: {
    user: {},
    editDisabled: {
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    form: {
      phones: [],
    },
    editMode: false,
    showPopup: false,
    phoneToRemove: -1,
  }),
  //vuelidate custom validations
  validations: {
    form: {
      phone: {}
    }
  },
  computed: {
    isButtonDisabled: function () {
      return this.v$.$invalid || this.isThereMoreThanOnePhoneNumberInAnyPhoneTypology;
    },
    isThereMoreThanOnePrivateTel() {
      return this.privateTelNumbers.length > 1;
    },
    isThereMoreThanOnePrivateMob() {
      return this.privateMobNumbers.length > 1;
    },
    isThereMoreThanOneBusinessTel() {
      return this.businessTelNumbers.length > 1;
    },
    isThereMoreThanOneBusinessMob() {
      return this.businessMobNumbers.length > 1;
    },
    isThereMoreThanOnePhoneNumberInAnyPhoneTypology() {
      return (
        this.isThereMoreThanOnePrivateTel ||
        this.isThereMoreThanOnePrivateMob ||
        this.isThereMoreThanOneBusinessTel ||
        this.isThereMoreThanOneBusinessMob
      );
    },
    privateTelNumbers() {
      return this.getFormFilteredPhones('PRIVATE', 'TEL') || [];
    },
    privateMobNumbers() {
      return this.getFormFilteredPhones('PRIVATE', 'MOB') || [];
    },
    businessTelNumbers() {
      return this.getFormFilteredPhones('BUSINESS', 'TEL') || [];
    },
    businessMobNumbers() {
      return this.getFormFilteredPhones('BUSINESS', 'MOB') || [];
    },
    privateTelLabel() {
      return this.getPhoneInfo('PRIVATE', 'TEL');
    },
    privateMobLabel() {
      return this.getPhoneInfo('PRIVATE', 'MOB');
    },
    businessTelLabel() {
      return this.getPhoneInfo('BUSINESS', 'TEL');
    },
    businessMobLabel() {
      return this.getPhoneInfo('BUSINESS', 'MOB');
    },
  },
  updated() {
    console.log(`update component`);
    // this.checkPreferredPhoneNumber();
    this.$emit('isEditMode', {subSection:'PPN', value: this.editMode});
  },
  watch : {
    "user": {
      handler(newVal, oldVal) {
        this.prefillForm();
      },
    },
  },
  async mounted(){
    this.prefillForm();
    this.checkPreferredPhoneNumber();
  },
  methods: {
    /**
     * Get the preferred phone 
     */
    checkPreferredPhoneNumber() {
      const validPhones = this.form.phones.sort(function(a,b){
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        if (a.updatedAt === undefined && b.updatedAt === undefined) return 0;
        else if (a.updatedAt === undefined && b.updatedAt !== undefined) return 1;
        else if (a.updatedAt !== undefined && b.updatedAt === undefined) return -1;
        else return new Date(b.updatedAt) - new Date(a.updatedAt);
      }).filter(p => p.delete === undefined);
      if (validPhones.length === 0) return;

      const preferredPhone = this.form.phones.find(p => p.preferred);
      if (preferredPhone && preferredPhone.delete === undefined) return;

      // if preferred phone is not valid
      this.handlePreferredPhone(validPhones[0]);
    },
    /**
     * Tracy tracking for change phn number intention and edit management
     */
    editClicked(elementId = ""){
      this.handleEditMode(true);
      if(elementId) {
        setTimeout(() => {
          document.getElementById(elementId)?.focus();
        }, 0)
      }
    },
    /**
     * Tracy tracking for change phn number cancelled and edit management
     */
    cancelEditClicked(){
      this.handleEditMode();
    },
    /**
     * edit number management
     */
    handleEditMode(isEditMode = false){
      this.editMode = isEditMode;

      if (isEditMode) {
        this.addBlankPhone('PRIVATE', 'TEL');
        this.addBlankPhone('PRIVATE', 'MOB');
        this.addBlankPhone('BUSINESS', 'TEL');
        this.addBlankPhone('BUSINESS', 'MOB');
      } else {
        this.prefillForm();
      }
    },
    /**
     * Form valorization
     */
    prefillForm() {
      this.form.phones = JSON.parse(JSON.stringify(this.getUserPhones()));
      
      /* this.form.phones = this.form.phones.sort(function(a,b){
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        if (a.updatedAt === undefined && b.updatedAt === undefined) return 0;
        else if (a.updatedAt === undefined && b.updatedAt !== undefined) return 1;
        else if (a.updatedAt !== undefined && b.updatedAt === undefined) return -1;
        else return new Date(b.updatedAt) - new Date(a.updatedAt);
      })
      .sort(function(a,b){
        if(a.preferred == b.preferred) return 0;
        else if (a.preferred && !b.preferred) return -1;
        else if (!a.preferred && b.preferred) return 1;
        else return 0;
      }) */
    },
    /**
     * Tracy tracking for add phn number cancelled or dd phn number intention and add management
     * TODO: implement
     */
    // applyClicked(){
    //   if (this.addMode){
    //     oneUtils.trackingUtils.trackTracyEvent('add phn number cancelled',{})
    //   }else{
    //     oneUtils.trackingUtils.trackTracyEvent('add phn number intention',{})
    //   }
    // },
    /**
    * Returns the list of the user's phones
    */
    getUserPhones() {
      let userPhones = [];
      if(this.user.communications) {
        userPhones = this.user.communications.communicationPhones ?? [];
      }
      return userPhones;
    },
    /**
     * Returns the list of the user's phones, filtered according to the provided parameters
     */
    getFormFilteredPhones(phoneStatus, phoneType) {
      let filteredUserPhones = [];

      filteredUserPhones = this.form.phones/*.sort(function(a,b){
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        if (a.updatedAt === undefined && b.updatedAt === undefined) return 0;
        else if (a.updatedAt === undefined && b.updatedAt !== undefined) return 1;
        else if (a.updatedAt !== undefined && b.updatedAt === undefined) return -1;
        else return new Date(b.updatedAt) - new Date(a.updatedAt);
      })*/.filter(phone =>
        phone.communicationStatus === phoneStatus &&
        phone.communicationType === phoneType &&
        phone.delete === undefined
      );

      return filteredUserPhones;
    },
    /**
     * Return phones info: types + status
     */
    getPhoneInfo(communicationStatus, communicationType){
      return this.$t(this.$c("list_of_phoneTypes").find((type)=>type.typeKey === communicationType).translationKey)+" - "+this.$t(this.$c("list_of_phoneStatus").find((type)=>type.typeKey === communicationStatus).translationKey);
    },
    /**
     * Hide delete phone number popup and update user phone number 
     */
    remove: function (isAutomaticSubmit = true) {
      this.showPopup = false;
      this.handleDeletePhone(this.phoneToRemove, isAutomaticSubmit);
    },
    onDeleteClick(phone) {
      this.phoneToRemove = phone;

      if(this.editMode) {
        this.remove(false);

        this.addBlankPhone('PRIVATE', 'TEL');
        this.addBlankPhone('PRIVATE', 'MOB');
        this.addBlankPhone('BUSINESS', 'TEL');
        this.addBlankPhone('BUSINESS', 'MOB');
      }
      else {
        this.openDeletePopup();
      }
    },
    /**
     * Show delete phone number popup
     */
    openDeletePopup() {
      this.showPopup = true;
    },
    /**
     * Hide delete phone number popup
     */
    closeDeletePopup() {
      this.showPopup = false;
    },
    /**
     * Form submit
     */
    applyChanges() {
      // apply changes on user
      this.submitUpdate();
      // exit edit mode
      this.handleEditMode();
    },
    /**
     * edit, add or delete phone number management
     */
    submitUpdate() {
      // filter blank values
      this.form.phones = this.form.phones.filter(p => p.value);

      // create objets if not exists
      oneUtils.utils.showLeftLoader();
      if(!this.user.communications) {
        this.user.communications = {
          communicationPhones:[]
        };
      } else if(!this.user.communications.communicationPhones) {
        this.user.communications.communicationPhones = [];
      }

      this.checkPreferredPhoneNumber();

      this.form.phones.forEach(phone => {
        if(phone.tmp) {
          delete phone.tmp;
        }
      });

      // apply changes from form to user
      // option 1
      this.user.communications.communicationPhones = JSON.parse(JSON.stringify(this.form.phones));
      // option 2
      // this.form.phones.forEach(formPhone => {
      //   if (formPhone.consGUID) {
      //     // edit
      //     const phone = this.getUserPhones().find(userPhone => userPhone.consGUID === formPhone.consGUID);
      //     phone.value = formPhone.value;
      //     phone.preferred = formPhone.preferred;
      //     if (formPhone.delete) phone['delete'] = formPhone.delete;
      //   } else {
      //     // add
      //     this.getUserPhones().push({ ...formPhone });
      //   }
      // })
    },
    /**
     *  Setting preferred phone number
     */
    handlePreferredPhone(phone){
      this.form.phones.forEach(p => {
        p.preferred = false;
      });
      phone.preferred = true;
      this.submitUpdate();
    },
    /**
     *  Delete phone number
     */
    handleDeletePhone(phone, isAutomaticUpdate = true){
      if (phone.consGUID) {
        phone['delete'] = true;
      } else {
        const index = this.form.phones.findIndex(p => p.value === phone.value &&
          p.communicationStatus === phone.communicationStatus &&
          p.communicationType === phone.communicationType);
        this.form.phones.splice(index, 1);
      }
      // reset phone to remove
      this.phoneToRemove = null;
      
      if(isAutomaticUpdate) {
        this.submitUpdate();
      }
    },

    addBlankPhone(phoneStatus, phoneType) {
      const userPhones = this.form.phones;
      // const userPhones = this.getUserPhones();
      const isAlreadyThere = this.getFormFilteredPhones(phoneStatus, phoneType).length > 0;
      if (isAlreadyThere) return;
      this.form.phones.push({
        "communicationType" : phoneType,
        "communicationStatus" : phoneStatus,
        "value" : null,
        "preferred": false,
        "tmp": new Date().getTime().toString(),
      });
    },
  },
};
</script>
